import { _Base } from "../_Base";
import { endpoints } from "../endpoints";

export class PortfolioPermissions extends _Base {
  endPointRoot = process.env.REACT_APP_ROOT_T_API;
  endPointRootRest = process.env.REACT_APP_ROOT_T_REST;
  async getObjects(folderToPoint, additionalCookies) {
    const url = this.endPointRoot + endpoints.portfoliosPermissions.objects;
    return this.preparePost(
      url,
      { folder: folderToPoint, additionalCookies },
      null
    );
  }

  async getPermissions(additionalCookies) {
    const url = this.endPointRoot + endpoints.portfoliosPermissions.permissions;
    return this.preparePost(url, { additionalCookies }, null);
  }

  async upload(json, additionalCookies) {
    const url = this.endPointRoot + endpoints.portfoliosPermissions.upload;
    return this.preparePost(url, { json, additionalCookies }, null);
  }

  async createNewUser(user) {
    const url =
      this.endPointRootRest + endpoints.portfoliosPermissions.createUser;

    return this.preparePost(url, user, null);
  }

  async deleteUser(user) {
    const url =
      this.endPointRootRest +
      endpoints.portfoliosPermissions.deleteUser +
      user.id;

    return this.prepareGet(url, null);
  }

  async updateUser(user) {
    const url =
      this.endPointRootRest + endpoints.portfoliosPermissions.updateUser;

    return this.preparePost(url, user, null);
  }

  async deleteUserFromPending(pendingId) {
    const url =
      this.endPointRootRest +
      endpoints.portfoliosPermissions.deleteUserFromPending +
      pendingId;

    return this.prepareGet(url, null);
  }
}
